document.addEventListener("DOMContentLoaded", () => {
  const MOBILE_MAX = 1100;

  function isDesktopLayout() {
    return window.innerWidth > MOBILE_MAX;
  }

  const mobileBurger = document.getElementById("mobileNavBurger");
  const mobileBackdrop = document.getElementById("mobileNavBackdrop");
  const mobilePanel = document.getElementById("mobileNavPanel");
  const mobileClose = document.getElementById("mobileNavClose");

  function resetMobileNavSubmenus() {
    if (!mobilePanel) return;
    mobilePanel.querySelectorAll(".mobile-nav-group").forEach((group) => {
      group.classList.remove("is-open");
      const btn = group.querySelector(".mobile-nav-group-toggle");
      const sub = group.querySelector(".mobile-nav-sub");
      if (btn) btn.setAttribute("aria-expanded", "false");
      if (sub) sub.setAttribute("hidden", "");
    });
  }

  function closeMobileMenu() {
    if (!mobileBurger || !mobileBackdrop || !mobilePanel) return;
    mobileBackdrop.classList.remove("is-active");
    mobilePanel.classList.remove("is-active");
    mobileBurger.classList.remove("is-active");
    mobileBurger.setAttribute("aria-expanded", "false");
    mobilePanel.setAttribute("aria-hidden", "true");
    mobileBackdrop.setAttribute("aria-hidden", "true");
    document.body.classList.remove("mobile-menu-open");
    mobileBurger.focus();
    resetMobileNavSubmenus();

    mobilePanel.querySelectorAll(".header-search-container").forEach((el) => {
      el.classList.remove("search-active");
      const wrap = el.querySelector(".header-search-input-wrapper");
      const inp = el.querySelector(".header-search-input");
      if (wrap) wrap.classList.remove("active");
      if (inp) {
        inp.value = "";
        inp.blur();
      }
    });
  }

  function openMobileMenu() {
    if (!mobileBurger || !mobileBackdrop || !mobilePanel) return;
    mobileBackdrop.classList.add("is-active");
    mobilePanel.classList.add("is-active");
    mobileBurger.classList.add("is-active");
    mobileBurger.setAttribute("aria-expanded", "true");
    mobilePanel.setAttribute("aria-hidden", "false");
    mobileBackdrop.setAttribute("aria-hidden", "false");
    document.body.classList.add("mobile-menu-open");
    if (mobileClose) mobileClose.focus();
  }

  if (mobileBurger && mobileBackdrop && mobilePanel) {
    mobileBurger.addEventListener("click", () => {
      const open = mobilePanel.classList.contains("is-active");
      if (open) closeMobileMenu();
      else openMobileMenu();
    });
    mobileBackdrop.addEventListener("click", closeMobileMenu);
    if (mobileClose) mobileClose.addEventListener("click", closeMobileMenu);

    window.addEventListener(
      "resize",
      () => {
        if (window.innerWidth > MOBILE_MAX) closeMobileMenu();
      },
      { passive: true },
    );

    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        mobilePanel.classList.contains("is-active") &&
        window.innerWidth <= MOBILE_MAX
      ) {
        closeMobileMenu();
      }
    });

    mobilePanel.querySelectorAll(".mobile-nav-group-toggle").forEach((btn) => {
      btn.addEventListener("click", () => {
        const group = btn.closest(".mobile-nav-group");
        const sub = group?.querySelector(".mobile-nav-sub");
        if (!group || !sub) return;
        const nextOpen = !group.classList.contains("is-open");
        group.classList.toggle("is-open", nextOpen);
        btn.setAttribute("aria-expanded", nextOpen ? "true" : "false");
        if (nextOpen) sub.removeAttribute("hidden");
        else sub.setAttribute("hidden", "");
      });
    });
  }

  let heroIdx = 0;
  let heroTimer;

  const slides = document.querySelectorAll(".hero-slide");
  const dots = document.querySelectorAll(".hero-dot");
  const heroLabel = document.getElementById("heroLabel");
  const heroTitle = document.getElementById("heroTitle");
  const heroExcerpt = document.getElementById("heroExcerpt");
  const heroNum = document.getElementById("heroNum");
  const heroRead = document.getElementById("heroRead");
  const heroPrev = document.getElementById("heroPrev");
  const heroNext = document.getElementById("heroNext");
  const mastheadSub = document.querySelector(".masthead-eyebrow");
  const masthead = document.querySelector(".masthead");
  const waveform = document.getElementById("waveform");
  const revealEls = document.querySelectorAll(".reveal");
  const scrollTopBtn = document.getElementById("scrollTopBtn");

  const heroReady =
    slides.length &&
    dots.length &&
    heroLabel &&
    heroTitle &&
    heroExcerpt &&
    heroNum &&
    heroPrev &&
    heroNext;

  if (heroReady) {
    function goHero(i) {
      slides[heroIdx].classList.remove("active");
      dots[heroIdx].classList.remove("active");

      heroIdx = (i + slides.length) % slides.length;

      slides[heroIdx].classList.add("active");
      dots[heroIdx].classList.add("active");

      const currentSlide = slides[heroIdx];
      const d = currentSlide.dataset;
      const href = d.permalink || d.href || "#";
      const label = d.category || d.label || "";
      heroLabel.textContent = label;
      heroLabel.href = href;
      heroTitle.href = href;
      heroTitle.innerHTML = (d.title || "").replace(/\n/g, "<br>");
      heroExcerpt.textContent = d.excerpt || "";
      heroNum.textContent = d.num || "";
      if (heroRead) heroRead.href = href;
    }

    function startTimer() {
      clearInterval(heroTimer);
      heroTimer = setInterval(() => goHero(heroIdx + 1), 6000);
    }

    heroNext.addEventListener("click", () => {
      goHero(heroIdx + 1);
      startTimer();
    });

    heroPrev.addEventListener("click", () => {
      goHero(heroIdx - 1);
      startTimer();
    });

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        goHero(Number(dot.dataset.dot));
        startTimer();
      });
    });

    startTimer();
  }

  function syncMastheadSticky() {
    const root = document.documentElement;
    if (!mastheadSub || !masthead) {
      root.style.removeProperty("--masthead-sticky-h");
      return;
    }
    if (!isDesktopLayout()) {
      mastheadSub.classList.remove("is-sticky");
      masthead.style.paddingBottom = "";
      root.style.removeProperty("--masthead-sticky-h");
      return;
    }
    const forceStickyHeader = document.body.classList.contains("short-h");
    const shouldStick = forceStickyHeader || window.scrollY > 300;
    const isSticky = mastheadSub.classList.contains("is-sticky");
    if (shouldStick && !isSticky) {
      masthead.style.paddingBottom = forceStickyHeader
        ? ""
        : `${mastheadSub.offsetHeight}px`;
      mastheadSub.classList.add("is-sticky");
    } else if (!shouldStick && isSticky) {
      mastheadSub.classList.remove("is-sticky");
      masthead.style.paddingBottom = "";
    } else if (forceStickyHeader && isSticky) {
      masthead.style.paddingBottom = "";
    }

    if (mastheadSub.classList.contains("is-sticky")) {
      root.style.setProperty("--masthead-sticky-h", `${mastheadSub.offsetHeight}px`);
    } else {
      root.style.setProperty("--masthead-sticky-h", "0px");
    }
  }

  window.addEventListener(
    "scroll",
    () => {
      syncMastheadSticky();
      if (scrollTopBtn) {
        scrollTopBtn.classList.toggle("visible", window.scrollY > 500);
      }
    },
    { passive: true },
  );

  window.addEventListener(
    "resize",
    () => {
      syncMastheadSticky();
    },
    { passive: true },
  );

  syncMastheadSticky();
  requestAnimationFrame(() => {
    syncMastheadSticky();
  });

  window.addEventListener(
    "load",
    () => {
      syncMastheadSticky();
    },
    { passive: true },
  );

  if ("MutationObserver" in window) {
    new MutationObserver(() => {
      syncMastheadSticky();
    }).observe(document.body, { attributes: true, attributeFilter: ["class"] });
  }

  if (scrollTopBtn) {
    scrollTopBtn.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  if (waveform) {
    const bars = 28;
    for (let i = 0; i < bars; i += 1) {
      const bar = document.createElement("div");
      bar.className = "w-bar";
      const h = 20 + Math.random() * 70;
      bar.style.height = `${h}px`;
      bar.style.animationDelay = `${i * 0.055}s`;
      bar.style.animationDuration = `${0.9 + Math.random() * 0.7}s`;
      waveform.appendChild(bar);
    }
  }

  if (revealEls.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 },
    );

    revealEls.forEach((el) => io.observe(el));
  } else if (revealEls.length) {
    revealEls.forEach((el) => el.classList.add("in"));
  }
});
